import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";

export class GoldAndRumAhoyFillingPot_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {


        
    protected override helpFactory: IHelpFactory = new GoldAndRumAhoyFillingPotHelpFactory();
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "yellow",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }
    //LED COLOR
    protected override ColorLed:string="255,255,0\n";            
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "GoldAndRumAhoyFillingPot");

        this.spinnableReelsParams.topBorderWidth = 7;
        this.spinnableReelsParams.bottomBorderWidth = 7;
    }

}

//Help Colorized
class GoldAndRumAhoyFillingPotHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new GoldAndRumAhoyFillingPotHelp(params);
    }
}

class GoldAndRumAhoyFillingPotHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}